import React from "react";
import { Box, Grid, Typography, Button, Chip, Snackbar, Alert } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import { tokens } from "../../theme";
import { aiSummary, aiRecs } from "../../data/mockData";

const disp = '"Space Grotesk", sans-serif';

export default function AIInsights() {
  const [snack, setSnack] = React.useState(null);
  const [dismissed, setDismissed] = React.useState({});

  return (
    <Box>
      <PageHeader
        title="AI Insights"
        crumb="Intelligence / AI Insights"
        subtitle="Structured brief · recommendations"
        actions={<Chip size="small" label="Proposes · humans dispose" sx={{ bgcolor: "rgba(91,168,245,0.13)", color: tokens.blue, fontWeight: 600 }} />}
      />

      <SectionCard title="Executive summary" subtitle="Auto-generated 18:00 · sent to Slack / Telegram / email" sx={{ mb: 1.75 }}>
        <Grid container spacing={1.5}>
          {aiSummary.map(([title, lines]) => (
            <Grid item xs={12} md={6} key={title}>
              <Box sx={{ border: `1px solid ${tokens.border}`, borderRadius: "9px", p: 1.5, background: tokens.bg2, height: "100%" }}>
                <Typography sx={{ fontSize: 12.5, fontWeight: 700, mb: 1 }}>{title}</Typography>
                {lines.map((x, i) => (
                  <Typography key={i} variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1.7 }}>• {x}</Typography>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      </SectionCard>

      <Typography sx={{ fontFamily: disp, fontWeight: 600, fontSize: 16, mb: 1.25 }}>Recommendation inbox</Typography>
      {aiRecs.map((r, i) => (
        <Box key={i} sx={{ border: `1px solid ${tokens.border}`, borderRadius: "10px", p: 1.75, mb: 1.25, background: tokens.cardBg, opacity: dismissed[i] ? 0.4 : 1, display: "flex", gap: 2, alignItems: "flex-start", flexWrap: "wrap" }}>
          <Box sx={{ flex: 1, minWidth: 220 }}>
            <Typography variant="body2">{r.txt}</Typography>
            <Typography sx={{ fontFamily: disp, fontWeight: 600, color: tokens.secondary, fontSize: 12.5, mt: 0.7 }}>{r.impact}</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button size="small" variant="contained" disabled={dismissed[i]} onClick={() => setSnack(`Accepted — routed to «${r.action}»`)}>Accept → {r.action}</Button>
            <Button size="small" variant="outlined" color="inherit" disabled={dismissed[i]} onClick={() => { setDismissed((d) => ({ ...d, [i]: true })); setSnack("Recommendation dismissed"); }}>Dismiss</Button>
          </Box>
        </Box>
      ))}

      <Snackbar open={Boolean(snack)} autoHideDuration={3000} onClose={() => setSnack(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert severity="success" variant="filled" onClose={() => setSnack(null)}>{snack}</Alert>
      </Snackbar>
    </Box>
  );
}
